import { skipToken } from '@reduxjs/toolkit/query';
import { useMemo } from 'react';
import { useGetVarietyQuery } from '../impl/blfApi/endpoints/varieties';

export const useVariety = (
  varietyId: string | undefined,
  queryOptions?: {
    skip?: boolean;
  }
) => {
  const queryParams = useMemo(() => {
    if (!varietyId || queryOptions?.skip) {
      return skipToken;
    }

    return varietyId;
  }, [varietyId, queryOptions?.skip]);

  const {
    data: variety,
    isLoading,
    isFetching,
  } = useGetVarietyQuery(queryParams, queryOptions);

  return {
    variety,
    isVarietyLoading: isLoading || isFetching,
  };
};
